import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { portfolioStore } from '../stores/portfolio-store';
import { EditAssetsUI } from '../ui/edit-assets-ui';
import { AssetDisplayData } from '../types';
import { isSuccess } from '../lib/utils/type-guards';

export const EditAssetsObserver: React.FC = observer(() => {
  const navigate = useNavigate();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState<AssetDisplayData | null>(null);

  const handleViewBucket = (bucketName: string): void => {
    navigate(`/edit-assets/bucket/${encodeURIComponent(bucketName)}`);
  };

  const handleDeleteBucket = async (bucketName: string): Promise<void> => {
    const result = await portfolioStore.removeBucket(bucketName);
    if (!isSuccess(result)) {
      console.error('Failed to delete bucket:', result);
    }
  };

  const handleEditAsset = (asset: AssetDisplayData): void => {
    setSelectedAsset(asset);
    setEditModalOpen(true);
  };

  const handleDeleteAsset = (asset: AssetDisplayData): void => {
    setSelectedAsset(asset);
    setDeleteModalOpen(true);
  };

  const handleCloseEditModal = (): void => {
    setEditModalOpen(false);
    setSelectedAsset(null);
  };

  const handleCloseDeleteModal = (): void => {
    setDeleteModalOpen(false);
    setSelectedAsset(null);
  };

  const getSelectedAssetData = () => {
    if (!selectedAsset) return null;
    return portfolioStore.getAsset(`${selectedAsset.id}_${selectedAsset.bucket}`);
  };

  return (
    <EditAssetsUI
      bucketDisplayData={portfolioStore.bucketDisplayData}
      totalAssets={portfolioStore.totalAssets}
      assetDisplayData={portfolioStore.assetDisplayData}
      selectedAsset={selectedAsset}
      selectedAssetData={getSelectedAssetData()}
      editModalOpen={editModalOpen}
      deleteModalOpen={deleteModalOpen}
      onViewBucket={handleViewBucket}
      onDeleteBucket={handleDeleteBucket}
      onEditAsset={handleEditAsset}
      onDeleteAsset={handleDeleteAsset}
      onCloseEditModal={handleCloseEditModal}
      onCloseDeleteModal={handleCloseDeleteModal}
    />
  );
});
